import React, { memo, useState } from 'react';
import { Stack, Typography } from 'investira.react.components';
import { validators } from 'investira.sdk';
import QuestaoCard from '../_components/QuestaoCard';

const AvaliacoesEditCategorias = memo(props => {
  const {
    categorias = {},
    activeCategoryId,
    activeQuestionId,
    onSelect,
    questoes,
    respostas = {},
    onQuestionChange
  } = props;

  const [selectedIndex, setSelectedIndex] = useState(1);

  const handleListItemClick = (pEvent, pIndex) => {
    setSelectedIndex(pIndex);
  };

  if (validators.isEmpty(activeCategoryId)) {
    return null;
  }

  const xSessaoAtual = categorias[activeCategoryId].sessao;

  return (
    <Stack gap={2}>
      <Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="caption" color="textSecondary" sx={{ textTransform: 'uppercase' }}>
            Sessão {xSessaoAtual}
          </Typography>
        </Stack>
        <Typography variant="h5" color="textPrimary">
          {categorias[activeCategoryId].label}
        </Typography>
      </Stack>
      <Stack gap={3}>
        {questoes &&
          questoes.map((xQuestao, xIndex) => {
            return (
              <QuestaoCard
                key={xQuestao.id}
                id={xQuestao.id}
                aliasId={`${xSessaoAtual}.${xIndex + 1}`}
                data={xQuestao}
                onSelect={onSelect}
                activeQuestionId={activeQuestionId}
                value={{ avaliado: respostas[xQuestao.id] === true }}
                onChange={onQuestionChange}
              />
            );
          })}
      </Stack>
    </Stack>
  );
});

export default AvaliacoesEditCategorias;
